export enum VerificationSMSType {
  DOWNLOAD = 'download',
  EDIT = 'edit',
}
